var _style, _rect, _defs, _polygon, _defs2, _polygon2, _defs3, _polygon3, _defs4, _polygon4, _defs5, _polygon5, _defs6, _polygon6, _defs7, _polygon7, _path, _defs8, _polygon8, _defs9, _polygon9, _defs10, _polygon10, _defs11, _polygon11, _defs12, _polygon12, _defs13, _polygon13, _defs14, _polygon14, _defs15, _polygon15, _defs16, _polygon16, _defs17, _polygon17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkylineLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 581.14 158.4",
    style: {
      enableBackground: "new 0 0 581.14 158.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000923;}\r\n\t.st1{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}\r\n\t.st2{clip-path:url(#SVGID_5_);fill:url(#SVGID_6_);}\r\n\t.st3{clip-path:url(#SVGID_8_);fill:url(#SVGID_9_);}\r\n\t.st4{clip-path:url(#SVGID_11_);fill:url(#SVGID_12_);}\r\n\t.st5{clip-path:url(#SVGID_14_);fill:url(#SVGID_15_);}\r\n\t.st6{clip-path:url(#SVGID_17_);fill:url(#SVGID_18_);}\r\n\t.st7{clip-path:url(#SVGID_20_);fill:url(#SVGID_21_);}\r\n\t.st8{fill:url(#SVGID_22_);}\r\n\t.st9{clip-path:url(#SVGID_24_);fill:url(#SVGID_25_);}\r\n\t.st10{clip-path:url(#SVGID_27_);fill:url(#SVGID_28_);}\r\n\t.st11{clip-path:url(#SVGID_30_);fill:url(#SVGID_31_);}\r\n\t.st12{clip-path:url(#SVGID_33_);fill:url(#SVGID_34_);}\r\n\t.st13{clip-path:url(#SVGID_36_);fill:url(#SVGID_37_);}\r\n\t.st14{clip-path:url(#SVGID_39_);fill:url(#SVGID_40_);}\r\n\t.st15{clip-path:url(#SVGID_42_);fill:url(#SVGID_43_);}\r\n\t.st16{clip-path:url(#SVGID_45_);fill:url(#SVGID_46_);}\r\n\t.st17{clip-path:url(#SVGID_48_);fill:url(#SVGID_49_);}\r\n\t.st18{clip-path:url(#SVGID_51_);fill:url(#SVGID_52_);}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1359.43,
    y: -415.27,
    className: "st0",
    width: 1080,
    height: 1080
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 118.56,
    y: 117.84,
    width: 6.91,
    height: 26.46
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -1360.5729,
    y1: 708.171,
    x2: -1359.7762,
    y2: 708.171,
    gradientTransform: "matrix(0.5966 26.5481 26.5481 -0.5966 -17867.041 36665.6953)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#035298"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "125.46,117.69 126.06,144.29 118.56,144.46 117.96,117.86  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_4_",
    points: "181.51,117.84 187.93,117.84 187.93,144.3 181.89,144.3 169.89,128.49 169.89,144.3 163.43,144.3  163.43,117.84 169.51,117.84 181.55,133.77  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -1360.5729,
    y1: 707.6553,
    x2: -1359.7762,
    y2: 707.6553,
    gradientTransform: "matrix(0.5966 26.5481 26.5481 -0.5966 -17799.7051 36664.1836)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#035298"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "187.92,117.29 188.52,144.29 163.45,144.85 162.84,117.86  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_7_",
    points: "225.94,117.84 245.72,117.84 245.68,123.35 232.85,123.35 232.85,129.24 244.7,129.24  244.7,134.75 232.85,134.75 232.85,144.3 225.94,144.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -1360.5729,
    y1: 707.0774,
    x2: -1359.7762,
    y2: 707.0774,
    gradientTransform: "matrix(0.5966 26.5481 26.5481 -0.5966 -17724.248 36662.4883)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#035298"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "245.71,117.4 246.31,144.29 225.95,144.74 225.34,117.86  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_10_",
    d: "M290.75,137.86c-1.11-0.69-2-1.63-2.66-2.83c-0.67-1.2-1-2.52-1-3.98c0-1.43,0.33-2.75,0.98-3.94 c0.65-1.2,1.54-2.13,2.66-2.81c1.12-0.68,2.33-1.02,3.64-1.02c1.31,0,2.51,0.34,3.6,1.02c1.1,0.68,1.96,1.62,2.59,2.81 c0.63,1.2,0.94,2.51,0.94,3.94c0,1.46-0.32,2.79-0.94,3.98c-0.63,1.2-1.49,2.14-2.59,2.83c-1.09,0.69-2.3,1.04-3.6,1.04 C293.06,138.9,291.85,138.56,290.75,137.86 M286.99,119.2c-2.18,1.18-3.89,2.81-5.13,4.87c-1.25,2.06-1.87,4.38-1.87,6.94 c0,2.59,0.62,4.94,1.87,7.04c1.25,2.1,2.96,3.75,5.13,4.94c2.18,1.19,4.61,1.79,7.3,1.79c2.69,0,5.13-0.6,7.3-1.81 c2.17-1.21,3.89-2.85,5.13-4.94c1.25-2.09,1.87-4.43,1.87-7.02c0-2.57-0.62-4.88-1.87-6.94c-1.25-2.06-2.96-3.69-5.13-4.87 c-2.18-1.18-4.61-1.78-7.3-1.78C291.6,117.43,289.17,118.02,286.99,119.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: -1360.5729,
    y1: 706.5156,
    x2: -1359.7762,
    y2: 706.5156,
    gradientTransform: "matrix(0.5966 26.5481 26.5481 -0.5966 -17650.8984 36660.8398)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#035298"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "308.58,116.78 309.21,144.78 280,145.43 279.37,117.44  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M349.57,118.31c-1.6,0.67-2.83,1.62-3.7,2.85c-0.87,1.23-1.3,2.67-1.3,4.3c0,1.74,0.42,3.13,1.27,4.17 c0.84,1.04,1.85,1.82,3.04,2.34c1.18,0.52,2.68,1.03,4.49,1.53c1.21,0.33,2.14,0.61,2.81,0.85c0.67,0.24,1.22,0.56,1.66,0.96 c0.44,0.4,0.66,0.91,0.66,1.51c0,0.73-0.3,1.28-0.89,1.66c-0.59,0.38-1.4,0.57-2.43,0.57c-1.41,0-3.03-0.38-4.85-1.13 c-1.83-0.76-3.4-1.72-4.74-2.91l-2.68,5.4c1.58,1.33,3.47,2.38,5.64,3.15c2.18,0.77,4.36,1.15,6.55,1.15 c1.99,0,3.79-0.31,5.42-0.94c1.62-0.63,2.9-1.57,3.83-2.81c0.93-1.25,1.4-2.75,1.4-4.51c0-1.76-0.43-3.19-1.28-4.28 c-0.86-1.1-1.88-1.91-3.08-2.44c-1.2-0.53-2.71-1.06-4.55-1.58c-1.23-0.38-2.16-0.68-2.79-0.92c-0.63-0.24-1.16-0.55-1.58-0.94 c-0.43-0.39-0.64-0.87-0.64-1.45c0-0.6,0.24-1.06,0.74-1.38c0.49-0.31,1.16-0.47,2.02-0.47c1.08,0,2.42,0.26,4.02,0.79 c1.6,0.53,3.1,1.21,4.51,2.04l2.6-5.51c-1.41-0.91-3.05-1.63-4.91-2.17c-1.86-0.54-3.75-0.81-5.66-0.81 C353.02,117.31,351.17,117.65,349.57,118.31"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: -1360.5729,
    y1: 705.939,
    x2: -1359.7762,
    y2: 705.939,
    gradientTransform: "matrix(0.5966 26.5481 26.5481 -0.5966 -17575.5879 36659.1484)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#035298"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "365.73,116.8 366.36,144.7 342.92,145.23 342.29,117.33  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_16_",
    points: "418.62,117.84 412.51,129.2 406.24,117.84 399.33,117.84 409.07,136.03 409.07,144.3  415.98,144.3 415.98,135.85 425.53,117.84  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_17_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_16_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: -1360.5729,
    y1: 705.3665,
    x2: -1359.7762,
    y2: 705.3665,
    gradientTransform: "matrix(0.5966 26.5481 26.5481 -0.5966 -17502.3125 36657.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#035298"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "425.52,117.25 426.12,144.29 399.35,144.89 398.74,117.86  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_19_",
    d: "M465.45,118.31c-1.6,0.67-2.83,1.62-3.7,2.85c-0.87,1.23-1.3,2.67-1.3,4.3c0,1.74,0.42,3.13,1.27,4.17 c0.84,1.04,1.85,1.82,3.04,2.34c1.18,0.52,2.68,1.03,4.49,1.53c1.21,0.33,2.14,0.61,2.81,0.85c0.67,0.24,1.22,0.56,1.66,0.96 c0.44,0.4,0.66,0.91,0.66,1.51c0,0.73-0.3,1.28-0.89,1.66c-0.59,0.38-1.4,0.57-2.43,0.57c-1.41,0-3.03-0.38-4.85-1.13 c-1.83-0.76-3.4-1.72-4.74-2.91l-2.68,5.4c1.59,1.33,3.47,2.38,5.64,3.15c2.18,0.77,4.36,1.15,6.55,1.15 c1.99,0,3.79-0.31,5.42-0.94c1.62-0.63,2.9-1.57,3.83-2.81c0.93-1.25,1.4-2.75,1.4-4.51c0-1.76-0.43-3.19-1.28-4.28 c-0.86-1.1-1.88-1.91-3.08-2.44c-1.2-0.53-2.71-1.06-4.55-1.58c-1.23-0.38-2.16-0.68-2.79-0.92c-0.63-0.24-1.16-0.55-1.58-0.94 c-0.43-0.39-0.64-0.87-0.64-1.45c0-0.6,0.24-1.06,0.74-1.38c0.49-0.31,1.16-0.47,2.02-0.47c1.08,0,2.42,0.26,4.02,0.79 c1.6,0.53,3.1,1.21,4.51,2.04l2.6-5.51c-1.41-0.91-3.05-1.63-4.91-2.17c-1.86-0.54-3.75-0.81-5.66-0.81 C468.9,117.31,467.04,117.65,465.45,118.31"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: -1360.5729,
    y1: 704.8257,
    x2: -1359.7762,
    y2: 704.8257,
    gradientTransform: "matrix(0.5966 26.5481 26.5481 -0.5966 -17430.2129 36655.8789)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#035298"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "481.61,116.8 482.23,144.7 458.8,145.23 458.17,117.33  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.8937,
    y1: 89.6275,
    x2: 78.5413,
    y2: 89.6275
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#035298"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M39.48,133.9c-9.41,0-17.46-8.51-17.58-18.57c-0.01-0.52,0.01-1.02,0.05-1.53L22,113.2l12.56-8.56l0.03,2.4 c0,0.34,0.07,2.76,0.14,5c0.05,1.95,0.11,3.77,0.11,4c0.03,2.59,2.1,4.69,4.62,4.69c2.6-0.03,4.64-2.19,4.61-4.81l-0.63-52.44 c-0.01-0.44,0-0.86,0.04-1.29c0.52-9.31,8.12-16.72,17.3-16.84l0.21,0c9.56,0,17.44,7.94,17.55,17.71 c0.01,0.84-0.04,1.59-0.15,2.45l-0.08,0.58l-12.58,8.27l-0.12-11.15c-0.03-2.59-2.1-4.69-4.62-4.69c-2.61,0.03-4.65,2.19-4.62,4.81 L57,115.77c0.02,1.67-0.18,3.31-0.6,4.86c-2.01,7.71-8.89,13.18-16.73,13.27L39.48,133.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_23_",
    d: "M1.59,42.2v75.44c0,0.84,0.02,1.84,0.15,2.82c0.24,2.13,0.68,4.32,1.31,6.51 c4.84,16.41,20.15,27.86,37.22,27.86l0.51,0c10.36-0.12,20.07-4.28,27.33-11.72c7.26-7.44,11.19-17.24,11.07-27.61l-0.25-43.08 L67.16,79.7l-0.19,35.95c0.09,7.1-2.61,13.82-7.59,18.92c-4.98,5.1-11.64,7.96-18.74,8.04l-0.32,0 c-12.95,0-23.97-9.25-26.22-22.02c-0.26-1.41-0.39-2.81-0.41-4.3l-0.05-3.62V42.2c0-3.32-2.7-6.03-6.03-6.03 C4.29,36.17,1.59,38.88,1.59,42.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: -1359.4821,
    y1: 672.5646,
    x2: -1358.6854,
    y2: 672.5646,
    gradientTransform: "matrix(3.3663 149.8024 149.8024 -3.3663 -96136.2266 205953.2656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#035298"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "79.28,34.43 81.98,154.77 1.63,156.58 -1.08,36.23  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_26_",
    d: "M59.66,24.41c-21.43,0.27-38.65,17.92-38.38,39.33l0,43.37l12.01-7.47l0.2-36.05 c-0.09-7.1,2.6-13.82,7.58-18.92c4.98-5.1,11.63-7.96,18.73-8.04l0.32,0c12.93,0,23.96,9.24,26.23,21.98 c0.26,1.5,0.4,2.91,0.41,4.34l0.04,2.64v77.76c0,3.32,2.7,6.02,6.02,6.02c3.32,0,6.02-2.7,6.02-6.02l0-83.34 c-0.01-0.19-0.03-0.39-0.06-0.62c-0.22-2.32-0.67-4.63-1.38-7.06c-4.82-16.44-20.14-27.92-37.26-27.92L59.66,24.41z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_27_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_26_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: -1359.4624,
    y1: 672.1365,
    x2: -1358.6658,
    y2: 672.1365,
    gradientTransform: "matrix(3.5442 157.7149 157.7149 -3.5442 -101129.2422 216814.0469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#035298"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "98.81,22.66 101.66,149.31 21.06,151.12 18.21,24.47  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_29_",
    d: "M134.4,35.44c-4.35,1.82-7.77,4.46-10.16,7.85c-2.4,3.41-3.62,7.42-3.62,11.92c0,4.79,1.2,8.71,3.57,11.65 c2.31,2.86,5.13,5.03,8.37,6.45c3.11,1.36,7.08,2.71,11.82,4.02c3.07,0.83,5.48,1.56,7.18,2.17c1.55,0.56,2.85,1.3,3.85,2.22 c0.86,0.78,1.27,1.74,1.27,2.92c0,1.43-0.53,2.43-1.67,3.16c-1.31,0.83-3.18,1.25-5.58,1.25c-3.45,0-7.51-0.95-12.04-2.83 c-4.57-1.89-8.57-4.34-11.89-7.29l-1.32-1.17l-8.19,16.5l0.81,0.68c4.21,3.54,9.27,6.37,15.03,8.4 c5.75,2.03,11.61,3.06,17.41,3.06c5.29,0,10.17-0.85,14.51-2.53c4.42-1.71,7.96-4.31,10.51-7.73c2.58-3.45,3.88-7.65,3.88-12.49 c0-4.85-1.21-8.86-3.61-11.92c-2.34-2.99-5.19-5.25-8.48-6.71c-3.14-1.39-7.16-2.79-11.93-4.16c-3.17-0.97-5.57-1.76-7.15-2.36 c-1.46-0.56-2.7-1.29-3.68-2.18c-0.83-0.76-1.22-1.64-1.22-2.77c0-1.1,0.41-1.87,1.29-2.43c2.47-1.58,7.58-1.31,14.49,0.97 c4.02,1.33,7.87,3.07,11.42,5.16l1.27,0.75l7.88-16.67l-0.99-0.64c-3.74-2.4-8.13-4.35-13.06-5.78 c-4.92-1.43-9.98-2.15-15.03-2.15C143.71,32.75,138.68,33.66,134.4,35.44"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: -1359.1804,
    y1: 678.06,
    x2: -1358.3837,
    y2: 678.06,
    gradientTransform: "matrix(4.1761 85.9083 85.9083 -4.1761 -52429.332 119632.5625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#035298"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "178.27,29.72 181.99,106.22 116.14,109.42 112.42,32.92  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_32_",
    points: "235.58,34.12 211.84,61.56 211.84,34.12 191.26,34.12 191.26,105.32 211.84,105.32 211.84,87.48  218.95,79.58 236.36,105.32 261,105.32 233.21,63.83 257.73,36.58 259.94,34.12  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_33_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_32_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: -1359.1804,
    y1: 677.8351,
    x2: -1358.3837,
    y2: 677.8351,
    gradientTransform: "matrix(4.1761 85.9083 85.9083 -4.1761 -52331.2813 119627.7891)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#035298"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "260.84,30.74 264.46,105.15 191.42,108.7 187.81,34.29  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_35_",
    points: "346.11,34.12 346.11,105.32 395.72,105.32 395.72,87.38 366.69,87.38 366.69,34.12  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: -1359.1804,
    y1: 677.4171,
    x2: -1358.3837,
    y2: 677.4171,
    gradientTransform: "matrix(4.1761 85.9083 85.9083 -4.1761 -52150.9258 119619.0234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#035298"
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "395.6,31.71 399.17,105.15 346.23,107.72 342.66,34.29  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_38_",
    x: 409.21,
    y: 34.12,
    width: 20.58,
    height: 71.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_39_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_38_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: -1359.1804,
    y1: 677.2543,
    x2: -1358.3837,
    y2: 677.2543,
    gradientTransform: "matrix(4.1761 85.9083 85.9083 -4.1761 -52088.4648 119615.9922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#035298"
    }
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "429.74,33.12 433.24,105.15 409.26,106.31 405.76,34.29  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_41_",
    points: "488.55,34.12 488.63,80.24 459.48,34.12 441.74,34.12 441.74,105.32 461.14,105.32 461.14,67.02  507.84,141.4 507.84,34.12  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: -1359.1804,
    y1: 677.0802,
    x2: -1358.3837,
    y2: 677.0802,
    gradientTransform: "matrix(4.1761 85.9083 85.9083 -4.1761 -52019.2305 119612.625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#035298"
    }
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "507.69,30.92 513.05,141.15 441.89,144.61 436.53,34.38  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_44_",
    points: "521.24,34.12 521.24,105.32 578.95,105.32 578.95,88.36 541.82,88.36 541.82,78.14 574.46,78.05  574.46,61.19 541.82,61.19 541.82,51.08 577.97,51.08 577.97,34.12  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_45_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_44_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: -1359.1804,
    y1: 676.8743,
    x2: -1358.3837,
    y2: 676.8743,
    gradientTransform: "matrix(4.1761 85.9083 85.9083 -4.1761 -51925.543 119608.0703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#035298"
    }
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "578.81,31.32 582.4,105.15 521.37,108.11 517.78,34.29  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_47_",
    points: "316.6,34.12 301.56,62.07 286.16,34.15 286.14,34.12 264.92,34.12 267.37,38.17 291.33,82.9  291.33,105.32 311.91,105.32 311.91,82.42 337.52,34.12  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_48_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_47_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: -1359.1804,
    y1: 677.5796,
    x2: -1358.3837,
    y2: 677.5796,
    gradientTransform: "matrix(4.1761 85.9083 85.9083 -4.1761 -52234.418 119623.0859)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#035298"
    }
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "337.35,30.6 340.97,105.15 265.09,108.84 261.47,34.29  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_50_",
    d: "M408.49,21.86c-1.08-2.39-1.31-4.88-0.81-7.45c0.02-0.1,0.01-0.22,0.15-0.27c0.4-0.14,0.67-0.41,0.86-0.79 c0.2-0.39,0.58-0.52,0.97-0.34c0.2,0.1,0.39,0.13,0.59,0.03c0.06-0.03,0.16-0.1,0.2-0.01c0.12,0.27,0.46,0.42,0.42,0.79 c-0.01,0.07,0.02,0.16,0.07,0.21c0.33,0.31,0.49,0.75,0.8,1.07c0.28,0.3,0.34,0.65,0.12,1.02c-0.13,0.21-0.13,0.42,0,0.62 c0.15,0.25,0.08,0.51-0.02,0.71c-0.28,0.54-0.72,0.95-1.17,1.35c-0.09,0.07-0.18,0.05-0.28,0.04c-0.42-0.05-0.84-0.08-1.26-0.2 c-0.39-0.11-0.7,0.22-0.57,0.61c0.08,0.24,0.04,0.45-0.04,0.67c-0.21,0.54-0.21,1.05,0.1,1.57c0.18,0.31,0.25,0.66,0.28,1.11 C408.66,22.33,408.59,22.09,408.49,21.86 M408.34,12.46c0.06-0.1,0.2-0.51,0.2-0.61c0-0.02,0.01-0.04,0.02-0.06 c0.27-0.57,0.58-1.12,0.95-1.64c0.08-0.11,0.14-0.11,0.28,0c0.23,0.17,0.41,0.52,0.81,0.39c-0.1,0.16-0.26,0.21-0.33,0.34 c-0.09,0.16-0.26,0.32-0.14,0.5c0.13,0.2,0.32,0.07,0.5,0.01c0.36-0.14,0.45-0.06,0.39,0.33c-0.01,0.09-0.02,0.17-0.02,0.26 c0.05,0.44-0.06,0.64-0.47,0.77c-0.3,0.1-0.66-0.1-0.71-0.42c-0.04-0.22-0.23-0.34-0.32-0.53c-0.05-0.11-0.58-0.03-0.62,0.09 c-0.12,0.36-0.49,0.54-0.63,0.95C408.16,12.64,408.28,12.56,408.34,12.46 M410.25,9.97c0.24-0.45,0.57-0.83,0.91-1.23 c0.05,0.26,0,0.37-0.26,0.63c-0.1,0.1-0.16,0.17-0.12,0.33c0.1,0.33-0.05,0.47-0.41,0.47c0,0,0,0,0,0 C410.21,10.17,410.19,10.09,410.25,9.97 M424.42,9.15c0.21-0.13,0.37-0.35,0.29-0.61c-0.1-0.33-0.23-0.67-0.63-0.77 c-0.2-0.05-0.48-0.07-0.55-0.25c-0.15-0.38-0.43-0.45-0.76-0.49c-0.06-0.01-0.13-0.03-0.19-0.06c-0.21-0.11-0.17-0.24,0-0.34 c0.19-0.11,0.35-0.03,0.48,0.14c0.1,0.13,0.23,0.24,0.4,0.07c0.11-0.12,0.6-0.2,0.68-0.08c0.27,0.4,0.63,0.53,1.09,0.47 c0.06-0.01,0.13,0.04,0.19,0.05c0.6,0.05,1.14,0.34,1.73,0.46c0.15,0.03,0.26,0.1,0.37,0.2c0.79,0.73,1.48,1.54,2.08,2.43 c0.22,0.32,0.25,0.6,0.05,0.93c-0.24,0.42-0.24,0.84-0.12,1.32c0.2,0.75,0.21,1.53-0.48,2.1c-0.08,0.07-0.1,0.16-0.12,0.26 c-0.11,0.65-0.55,1.13-0.85,1.69c0.1-0.4,0.19-0.8,0.49-1.11c0.04-0.04,0.05-0.12,0.07-0.18c0.03-0.11,0.07-0.24-0.05-0.29 c-0.15-0.06-0.16,0.11-0.2,0.2c-0.16,0.37-0.39,0.71-0.65,1.01c-0.22,0.26-0.4,0.52-0.45,0.85c-0.03,0.15-0.06,0.31-0.19,0.36 c-0.52,0.21-0.95,0.67-1.58,0.62c-0.13-0.01-0.24,0.04-0.31,0.15c-0.13,0.22-0.33,0.3-0.57,0.34c-0.36,0.06-0.67,0.2-0.76,0.61 c-0.03,0.14-0.14,0.21-0.27,0.27c-0.25,0.13-0.51,0.25-0.76,0.38c-0.07,0.04-0.14,0.09-0.19-0.02c-0.06-0.14-0.14-0.23-0.3-0.18 c-0.08,0.03-0.14,0.08-0.14,0.16c0,0.17,0.16,0.18,0.26,0.26c0.32,0.25,0.58,0.54,0.54,0.98c-0.03,0.37,0.09,0.65,0.36,0.9 c0.18,0.17,0.27,0.39,0.16,0.64c-0.04,0.08-0.05,0.14,0.01,0.21c0.2,0.24,0.08,0.42-0.13,0.57c-0.16,0.11-0.27,0.25-0.35,0.43 c-0.26,0.61-0.68,1.06-1.29,1.34c-0.3,0.13-0.42,0.35-0.42,0.67c-0.01,0.66,0.19,1.28,0.3,1.92c0.06,0.33,0.04,0.65-0.08,0.93 c-0.09,0.22-0.39,0.12-0.6,0.18c-0.21,0.06-0.38,0.02-0.51-0.17c-0.06-0.09-0.17-0.13-0.27-0.17c-0.33-0.12-0.59-0.45-1-0.38 c-0.05,0.01-0.12-0.09-0.18-0.14c-0.09-0.07-0.18-0.17-0.28-0.22c-0.57-0.28-1.03-0.66-1.3-1.26c-0.06-0.14-0.2-0.2-0.33-0.24 c-0.23-0.07-0.46-0.13-0.7-0.18c-0.11-0.03-0.23-0.04-0.28-0.15c-0.18-0.38-0.52-0.69-0.59-1.12c-0.06-0.4-0.24-0.69-0.56-0.95 c-0.34-0.28-0.22-0.66,0.14-0.86c0.41-0.23,0.89-0.24,1.28-0.47c0.3-0.18,0.61-0.28,0.96-0.3c0.15-0.01,0.22-0.04,0.26-0.21 c0.17-0.67,0.37-0.82,1.08-0.85c0.19-0.01,0.36-0.07,0.46-0.21c0.22-0.31,0.61-0.35,0.87-0.6c0.1-0.09,0.26-0.1,0.4-0.1 c0.29,0,0.58-0.05,0.85-0.17c0.25-0.11,0.4-0.09,0.47,0.19c0.01,0.05,0.03,0.11,0.1,0.12c0.07,0,0.12-0.06,0.13-0.12 c0.02-0.07,0.03-0.15,0.04-0.22c0.05-0.46,0.2-0.58,0.65-0.45c0.31,0.08,0.48-0.06,0.6-0.31c0.08-0.16,0.07-0.34,0.04-0.51 c-0.06-0.36,0.07-0.56,0.42-0.53c0.49,0.03,0.71-0.16,0.47-0.79c-0.03-0.08-0.08-0.15-0.12-0.23c-0.06-0.11-0.02-0.17,0.1-0.17 c0.21-0.01,0.38,0.02,0.48,0.25c0.19,0.45,0.72,0.54,1.08,0.17c0.28-0.29,0.47-0.64,0.33-1.04c-0.16-0.45-0.29-1.02-0.89-1.05 c-0.55-0.02-1.04-0.42-1.64-0.19c-0.2,0.08-0.35,0.12-0.4,0.34c-0.04,0.19-0.1,0.38-0.23,0.53c-0.05,0.05-0.11,0.12-0.2,0.07 c-0.07-0.04-0.06-0.11-0.06-0.17c0.01-0.22,0.09-0.43,0.15-0.64c0.12-0.41,0.07-0.57-0.29-0.8c-0.37-0.25-0.62-0.57-0.71-1.02 c-0.04-0.2-0.16-0.33-0.28-0.49c-0.23-0.31-0.58-0.5-0.77-0.84c-0.3-0.52-0.87-0.41-1.37-0.66c0.08,0.2,0.19,0.21,0.26,0.27 c0.04,0.04,0.08,0.08,0.05,0.14c-0.03,0.06-0.1,0.06-0.14,0.02c-0.18-0.19-0.44-0.21-0.7-0.34c0.15-0.05,0.26-0.07,0.35-0.12 c0.19-0.11,0.43-0.3,0.33-0.48c-0.14-0.26-0.02-0.25,0.1-0.23c0.03,0,0.05,0.01,0.08,0c0.24-0.01,0.45,0.07,0.63,0.23 c0.06,0.06,0.11,0.17,0.27,0.1c-0.23-0.25-0.48-0.43-0.77-0.56c-0.54-0.25-1.16,0.02-1.71-0.29c-0.33-0.19-0.47-0.26-0.4-0.71 c0.05-0.33,0.3-0.55,0.63-0.47c0.37,0.09,0.55-0.02,0.71-0.37c0.19-0.4,0.28-0.4,0.65-0.18c0.23,0.14,0.54,0.08,0.63-0.18 c0.09-0.26,0.31-0.36,0.52-0.46c0.27-0.12,0.59-0.1,0.87-0.04c0.2,0.04,0.01,0.31,0.06,0.47c0.02,0.05,0.04,0.1,0.07,0.15 c0.05,0.1,0.03,0.18-0.03,0.27c-0.23,0.35-0.22,0.4,0.12,0.65c0.17,0.13,0.23,0.27,0.2,0.48c-0.03,0.2-0.03,0.44,0.22,0.47 c0.24,0.03,0.27-0.21,0.33-0.38c0.01-0.03,0.01-0.06,0.01-0.1c0.08-0.41,0.3-0.57,0.72-0.52c0.07,0.01,0.14,0.01,0.21,0.01 C423.92,9.36,424.18,9.3,424.42,9.15 M422.22,5.82c0.03-0.07,0.1-0.06,0.17-0.06c0.28,0.01,0.44,0.15,0.46,0.43 c0.14-0.03,0.18-0.12,0.22-0.21c0.07-0.16,0.19-0.07,0.28-0.04c0.1,0.03,0.19,0.11,0.16,0.21c-0.02,0.08-0.14,0.21-0.16,0.21 c-0.32,0.01-0.68,0.08-0.94-0.04c-0.57-0.27-0.98,0.04-1.44,0.25c-0.08,0.04-0.17,0.12-0.09,0.2c0.18,0.18,0.27,0.5,0.63,0.46 c0.09-0.01,0.2-0.01,0.29,0.11c-0.11,0.08-0.21,0.08-0.29,0.03c-0.3-0.16-0.53-0.03-0.78,0.14c-0.26,0.17-0.57,0.26-0.9,0.3 c0.07-0.19,0.29-0.13,0.33-0.3c-0.17-0.06-0.3,0.04-0.45,0.07c-0.08,0.01-0.16,0.03-0.2-0.06c-0.04-0.09,0.05-0.14,0.11-0.18 c0.1-0.06,0.22-0.11,0.31-0.17c0.07-0.04,0.19-0.09,0.14-0.19c-0.05-0.1-0.16-0.14-0.28-0.08c-0.07,0.03-0.15,0.06-0.2,0.11 c-0.13,0.12-0.25,0.08-0.39,0.02c-0.06-0.03-0.14-0.03-0.14-0.11c0-0.1,0.09-0.11,0.16-0.13c0.21-0.07,0.42-0.12,0.62-0.2 c0.13-0.05,0.36-0.03,0.25-0.31c-0.04-0.1,0.06-0.09,0.12-0.1c0.3-0.05,0.65-0.1,0.87-0.23c0.31-0.18,0.5-0.06,0.76-0.01 c0.05,0.01,0.11,0.03,0.18,0.03C422.08,5.96,422.17,5.93,422.22,5.82 M415.53,7.66c-0.02-0.11,0.03-0.22,0-0.32 c-0.07-0.24,0.07-0.61-0.24-0.7c-0.31-0.1-0.58-0.22-0.8-0.45c-0.05-0.05-0.18-0.02-0.15-0.13c0.02-0.08,0.11-0.1,0.18-0.13 c0.47-0.21,0.95-0.39,1.44-0.54c0.93-0.28,1.87-0.45,2.88-0.5c-0.33,0.27-0.59,0.57-1.02,0.68c0.11,0.09,0.19,0.08,0.27,0.08 c0.02,0,0.05,0,0.07,0c0.08,0.01,0.2,0,0.18,0.13c-0.01,0.1-0.11,0.07-0.19,0.07c-0.09-0.01-0.19-0.05-0.32,0.01 c0.43,0.32,0.44,0.49,0.06,0.83c-0.13,0.11-0.22,0.24-0.3,0.38c-0.23,0.38-0.57,0.57-1.01,0.54c-0.26-0.01-0.49,0-0.69,0.2 c-0.06,0.05-0.11,0.08-0.17,0.08C415.63,7.89,415.55,7.81,415.53,7.66 M419.49,4.2c-7.03,0-12.71,5.71-12.71,12.75 c0,6.99,5.71,12.69,12.7,12.69c7.03,0,12.74-5.68,12.74-12.69C432.23,9.89,426.54,4.2,419.49,4.2 C419.49,4.2,419.49,4.2,419.49,4.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_51_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_50_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: -1359.1339,
    y1: 703.3257,
    x2: -1358.3373,
    y2: 703.3257,
    gradientTransform: "matrix(0.8949 27.8904 27.8904 -0.8949 -17980.627 38541.3281)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#035298"
    }
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "432.2,3.38 433.04,29.62 406.8,30.46 405.96,4.22  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkylineLogo);
export default __webpack_public_path__ + "static/media/skylineLogo.6078a4abd6d4907ba92d918011fa45a2.svg";
export { ForwardRef as ReactComponent };